import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import NewHero from '../../components/NewHero/NewHero';
import ServicesPreview from '../../components/ServicesPreview/ServicesPreview';
import StatsBar from '../../components/home/StatsBar';
import PortfolioPreview from '../../components/home/PortfolioPreview';
import ProcessSection from '../../components/home/ProcessSection';
import TestimonialsSection from '../../components/TestimonialsSection/TestimonialsSection';
import TechStack from '../../components/TechStack/TechStack';
import HomePricing from '../../components/home/HomePricing';
import HomeCTA from '../../components/home/HomeCTA';
import LmsProductBanner from '../../components/home/LmsProductBanner';

const HomeContainer = styled.div`
  position: relative;
  overflow-x: hidden;
  background: #fff;
`;

const SectionWrap = styled(motion.div)`
  position: relative;
`;

const sectionReveal = {
  hidden: { opacity: 0, y: 32 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.55, ease: [0.22, 1, 0.36, 1] },
  },
};

const wrap = (child) => (
  <SectionWrap
    initial="hidden"
    whileInView="visible"
    variants={sectionReveal}
    viewport={{ once: true, margin: '-50px' }}
  >
    {child}
  </SectionWrap>
);

const Home = () => (
  <HomeContainer>
    <NewHero />
    {wrap(<ServicesPreview />)}
    {wrap(<LmsProductBanner />)}
    <StatsBar />
    {wrap(<PortfolioPreview />)}
    {wrap(<ProcessSection />)}
    {wrap(<TestimonialsSection />)}
    {wrap(<TechStack />)}
    {wrap(<HomePricing />)}
    {wrap(<HomeCTA />)}
  </HomeContainer>
);

export default Home;
